import { render, staticRenderFns } from "./AutoRefreshSwitcher.vue?vue&type=template&id=abc15798"
import script from "./AutoRefreshSwitcher.vue?vue&type=script&lang=js"
export * from "./AutoRefreshSwitcher.vue?vue&type=script&lang=js"
import style0 from "./AutoRefreshSwitcher.vue?vue&type=style&index=0&id=abc15798&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports